@if (isReadOnly()) {
  <div class="borderColor mb-2 flex flex-col gap-2 rounded-xl border px-4 py-2 shadow-xl">
    <div class="flex w-full items-center gap-3">
      <div class="relative h-14 w-14 shrink-0 overflow-hidden bg-gray-300 shadow-lg">
        @if (isLoadingFile()) {
          <app-loading />
        } @else {
          <img [src]="previewImageUrl()" class="rounded-lg object-contain shadow-2xl" alt="File Preview" />
        }
      </div>
      <div class="flex w-full items-center justify-between gap-3">
        <h3 class="text-sm font-bold">{{ productTitle() }}</h3>
      </div>
    </div>

    <div class="flex w-full flex-col gap-2 border-t border-gray-100 pt-1.5">
      @for (product of products(); track product.id) {
        <div class="flex w-full items-center justify-between">
          <div class="flex flex-col gap-0.5">
            <p class="text-sm font-semibold">{{ isArabic() ? product.product.titleAr : product.product.titleEn }}</p>
            <div class="flex items-center gap-5 text-[13px] text-gray-600">
              <span class="flex items-center gap-1">
                <app-customer-price-icon />
                {{ product.product.peoplePrice }}
                <span i18n="@@EGP">EGP</span>
              </span>
              <span class="flex items-center gap-1">
                <app-business-price-icon />
                {{ product.product.storePrice }}
                <span i18n="@@EGP">EGP</span>
              </span>
            </div>
            <div class="flex items-center gap-5 text-[13px] text-gray-600">
              <span class="flex items-center gap-1">
                <app-mfg-exp-dates-icon />
                {{ concatenationDate(product.product.mfgDate, product.product.expDate) }}
              </span>
              <span class="flex items-center gap-1">
                <app-batch-number-icon />
                {{ product.product.batchNumber }}
              </span>
            </div>
          </div>
          <div class="borderColor flex items-center gap-1 rounded-md border px-2 py-0.5 text-[12px]">
            <span i18n="@@quantity">Quantity</span>
            <span>:</span>
            <span>{{ product.quantity }}</span>
          </div>
        </div>
      }
    </div>

    <div class="flex flex-col gap-1.5 border-t border-gray-100 pt-3 text-sm">
      <div class="flex items-center justify-end gap-2">
        <span class="w-36 text-right font-bold text-gray-800" i18n="@@totalPeoplePrice">Total People Price:</span>
        <p class="w-24 text-left">
          {{ totalPeoplePriceComputed() }}
          <span i18n="@@EGP">EGP</span>
        </p>
      </div>
      <div class="flex items-center justify-end gap-2">
        <span class="w-36 text-right font-bold text-gray-800" i18n="@@totalPharmacyPrice">Total Pharmacy Price:</span>
        <p class="w-24 text-left">
          {{ displayPharmacyPrice().toFixed(2) }}
          <span i18n="@@EGP">EGP</span>
        </p>
      </div>
    </div>
  </div>
} @else {
  <div class="borderColor relative mb-2 rounded-xl border px-5 py-4 shadow-xl">
    <div class="flex w-full items-start justify-between gap-6 border-b border-gray-300 pb-4">
      <div class="relative w-[10.5rem] overflow-hidden bg-gray-300 shadow-lg">
        @if (isLoadingFile()) {
          <app-loading />
        } @else {
          <div
            [class.right-0]="isArabic()"
            [class.left-0]="!isArabic()"
            class="absolute top-[-38px] right-[1rem] flex h-full w-[1rem] rotate-[314deg] items-center justify-center bg-green-700 text-sm text-white">
            <span class="absolute top-[50px] left-[-2px] rotate-[92deg] text-center text-[10px]">
              {{ isArabic() ? "باقة" : "bundle" }}
            </span>
          </div>
          <img [src]="previewImageUrl()" class="rounded-lg object-contain shadow-2xl" alt="File Preview" />
        }
      </div>
      <div class="w-full">
        <h3 class="my-2 mb-6 text-xl font-bold">
          {{ productTitle() }}
        </h3>
        <div class="flex w-full flex-col gap-6">
          @for (product of products(); track product.id) {
            <div class="flex w-full items-start justify-between pb-2">
              <div>
                <p>{{ isArabic() ? product.product.titleAr : product.product.titleEn }}</p>
                <div class="w-full">
                  <div class="grid grid-cols-2 gap-x-6 gap-y-2">
                    <div class="flex items-center gap-2">
                      <app-customer-price-icon />
                      <span>
                        {{ product.product.peoplePrice }}
                        <span i18n="@@EGP">EGP</span>
                      </span>
                    </div>
                    <div class="flex items-center gap-2">
                      <app-business-price-icon />
                      <span>
                        {{ product.product.storePrice }}
                        <span i18n="@@EGP">EGP</span>
                      </span>
                    </div>

                    <div class="flex items-center gap-2">
                      <app-mfg-exp-dates-icon />
                      <span>{{ concatenationDate(product.product.mfgDate, product.product.expDate) }}</span>
                    </div>
                    <div class="flex items-center gap-2">
                      <app-batch-number-icon />
                      <span>{{ product.product.batchNumber }}</span>
                    </div>
                  </div>
                </div>
                @if (!isReadOnly()) {
                  <div class="mt-2">
                    <app-item-quantity-status
                      [quantity]="product.quantity.toString()"
                      [packageQuantity]="getPackageDataFor(product).packageQuantity"
                      [notPackageRows]="getPackageDataFor(product).notPackageRows"
                      [editable]="isPrinted() && !isReadOnly()"
                      [isPrinted]="isPrinted() && !isReadOnly()"
                      [isPartiallyPackaged]="isPartiallyPackaged()"
                      [showOnlyPackaged]="showOnlyPackaged()"
                      (open)="onOpenProductPackageModal(product)"
                      [receiveReturnedProductsView]="receiveReturnedProductsView()" />
                  </div>
                }
              </div>

              <div class="borderColor flex gap-2 rounded-lg border px-2 py-1">
                <span i18n="@@quantity">Quantity</span>
                <span>:</span>
                <span>{{ product.quantity }}</span>
              </div>
            </div>
          }
        </div>

        <div class="mt-2">
          @if (showShortageActions()) {
            <div class="mt-2 flex items-center justify-end gap-3">
              <button
                type="button"
                (click)="onDropAllClick()"
                class="borderTabsColor textTabsColor hover-bg-primary-10 flex w-44 cursor-pointer items-center justify-center gap-2 rounded-xl border bg-white px-4 py-2.5 text-sm font-semibold transition-colors">
                <svg class="h-4 w-4 shrink-0" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
                {{ isArabic() ? "إزالة الكل" : "Drop All" }}
              </button>
              <button
                type="button"
                (click)="onConvertClick()"
                class="bgTabsColor hover-bg-primary-hover flex w-44 cursor-pointer items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold text-white transition-colors">
                <svg class="h-4 w-4 shrink-0" fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
                </svg>
                {{ isArabic() ? "تحويل إلى منتجات" : "Convert to Products" }}
              </button>
            </div>
          } @else if (confirmAction()) {
            <span class="mt-2 inline-block rounded-lg bg-gray-100 px-4 py-2 text-[13px] font-bold text-gray-600">
              {{
                confirmAction() === "CONVERT"
                  ? isArabic()
                    ? "تم التحويل"
                    : "Converted"
                  : isArabic()
                    ? "تم الإسقاط"
                    : "Dropped All"
              }}
            </span>
          }
        </div>
      </div>
    </div>

    <div class="flex flex-col gap-1.5 border-t border-gray-100 pt-3 text-sm">
      <div class="flex items-center justify-end gap-2">
        <span class="w-36 text-right font-bold text-gray-800" i18n="@@totalPeoplePrice">Total People Price:</span>
        <p class="w-24 text-left">
          {{ totalPeoplePriceComputed() }}
          <span i18n="@@EGP">EGP</span>
        </p>
      </div>
      <div class="flex items-center justify-end gap-2">
        <span class="w-36 text-right font-bold text-gray-800" i18n="@@totalPharmacyPrice">Total Pharmacy Price:</span>
        <p class="w-24 text-left">
          {{ displayPharmacyPrice().toFixed(2) }}
          <span i18n="@@EGP">EGP</span>
        </p>
      </div>
    </div>
  </div>
}
